import type { AnnouncementRecord } from '../lib/types';
import { cn } from '../lib/cn';
import { Info, AlertTriangle, OctagonAlert } from 'lucide-react';

const STYLES: Record<AnnouncementRecord['level'], { wrap: string; icon: typeof Info }> = {
  INFO: {
    wrap: 'bg-gradient-to-br from-brand-navy to-brand-navy-dark text-white',
    icon: Info,
  },
  WARN: {
    wrap: 'bg-gradient-to-br from-status-warning to-brand-orange-dark text-white',
    icon: AlertTriangle,
  },
  CRITICAL: {
    wrap: 'bg-gradient-to-br from-status-critical to-red-700 text-white',
    icon: OctagonAlert,
  },
};

export const AnnouncementBanner = ({ items }: { items: AnnouncementRecord[] }) => {
  if (items.length === 0) return null;
  return (
    <div className="space-y-2">
      {items.map((a) => {
        const { wrap, icon: Icon } = STYLES[a.level];
        return (
          <div
            key={a.id}
            role="status"
            className={cn('flex items-start gap-3 rounded-lg p-4 shadow-sm', wrap)}
          >
            <Icon className="mt-0.5 h-5 w-5 shrink-0" aria-hidden="true" />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold">{a.title}</div>
              <div className="mt-0.5 text-sm opacity-90">{a.body}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
